export default __webpack_public_path__ + "static/screenshot-timeseries-chart--mobile-42d7e797f1a6471b71ff1bc587ea0c09.webp";